import styled, { css } from "styled-components";
import { BackOutlined } from "@assets";
import { IMG_TOP_BG } from "@assets";

export const barColor = css`
  ${(props) => props.theme.primarySolid}
`;

export const Bar = styled.div`
  min-height: 70px;
  padding-inline: 15px 16px;
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  background: ${(props) =>
    props.bg === "transparent" ? "transparent" : barColor};
  z-index: 1000;
  elevation: 0;
`;

export const Title = styled.div`
  width: 100%;
  color: ${(props) => props.theme.textColor};
  text-align: center;

  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;

  @media screen and (max-width: 325px) {
    font-size: 16px;
  }

  @media screen and (max-width: 295px) {
    font-size: 15px;
  }
`;

export const BackIcon = styled(BackOutlined)`
  position: absolute;
  left: 16px;
  font-size: 24px;
  color: ${(props) => props.theme.textColor};
  cursor: pointer;

  @media screen and (max-width: 325px) {
    width: 24px !important;
  }

  @media screen and (max-width: 295px) {
    width: 23px !important;
  }
`;

export const RightIcon = styled.div`
  position: absolute;
  right: 16px;
  cursor: pointer;
  padding-top: 6px;

  font-size: 28px;
  color: ${(props) => props.theme.textColor};

  svg {
    font-size: 28px;
    color: ${(props) => props.theme.textColor};
  }

  @media screen and (max-width: 325px) {
    svg {
      width: 24px !important;
    }
  }

  @media screen and (max-width: 295px) {
    svg {
      width: 23px !important;
    }
  }
`;

export const TopBgImage = styled.img.attrs({
  alt: "bg-img",
  src: IMG_TOP_BG,
})`
  position: absolute;
  top: 0;
  width: 100%;
  height: 290px;
`;
